// ============================================================
// effectFieldParts - the two controls every effect's fields are made of:
// a choice from a list, and an amount. Shared by the attack effects
// (EffectList) and the sheet tier (SheetEffectFields).
// ============================================================
import NumberInput from '../NumberInput';
import common from '../../styles/common.module.css';
import styles from '../../styles/Stances.module.css';

/** A choice from a list. */
export function Pick<T extends string>(props: {
  value: T;
  options: readonly { id: T; label: string }[];
  onPick: (id: T) => void;
  label: string;
  locked: boolean;
}) {
  return (
    <select
      className={common.input}
      aria-label={props.label}
      value={props.value}
      disabled={props.locked}
      onChange={(e) => props.onPick(e.target.value as T)}
    >
      {props.options.map((o) => (
        <option key={o.id} value={o.id}>
          {o.label}
        </option>
      ))}
    </select>
  );
}

/** An amount; negative unless a least is given. */
export function Amount(props: {
  value: number;
  onChange: (n: number) => void;
  label: string;
  locked: boolean;
  min?: number;
}) {
  return (
    <NumberInput
      className={`${common.input} ${styles.narrow}`}
      aria-label={props.label}
      value={props.value}
      onChange={props.onChange}
      allowNegative={props.min === undefined}
      min={props.min}
      disabled={props.locked}
    />
  );
}
